import { z } from "zod";
import { ATHLETICS_UNITS } from "../types/athletics-competition.js";

// 117 -- create a discipline (competition) under an athletics match.
export const createCompetitionSchema = z.object({
  discipline: z.string().trim().min(1, "Discipline is required").max(60),
  unit: z.enum(ATHLETICS_UNITS).default("seconds"),
  // 178 -- wind reading in m/s; finite + realistic bounds.
  wind_assistance: z.number().finite().min(-20).max(20).optional().nullable(),
});

// Add or update an entry's result. All result fields are optional so the same
// schema covers "add athlete" and "record result" / "disqualify".
export const upsertEntrySchema = z.object({
  athlete_name: z.string().trim().min(1, "Athlete name is required").max(120),
  school_id: z.string().nullable().optional(),
  // 176 -- a 0.00s race (or negative time) ranks first under ascending sort.
  // A result is only ever a positive measurement; absence is null, not 0.
  result_value: z.number().positive("result_value must be positive").finite().nullable().optional(),
  result_display: z.string().max(40).nullable().optional(),
  attempt_count: z.number().int().min(0).max(99).optional(),
  dq: z.boolean().optional(),
  dq_reason: z.string().max(200).nullable().optional(),
  pb: z.boolean().optional(),
});

export type CreateCompetitionInput = z.infer<typeof createCompetitionSchema>;
export type UpsertEntryInput = z.infer<typeof upsertEntrySchema>;
